var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.028,
    height: 23.614,
    viewBox: "0 0 22.028 23.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checklist-_1_",
    transform: "translate(56.5 495.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24347",
    "data-name": "Path 24347",
    d: "M36.886-495.631c-.355.163-.468.409-.468,1.035v.463l-.774.02a3.381,3.381,0,0,0-1.064.128,3.085,3.085,0,0,0-1.986,2.03c-.089.261-.094.6-.094,8.87s0,8.609.094,8.87a3.094,3.094,0,0,0,2.05,2.05c.261.089.6.094,8.846.094,9.343,0,8.747.02,9.363-.281a2.878,2.878,0,0,0,1.375-1.37c.32-.641.3.01.3-9.388,0-8.279,0-8.585-.094-8.846a3.036,3.036,0,0,0-1.542-1.848,2.843,2.843,0,0,0-1.5-.306l-.769-.025-.02-.532c-.01-.448-.03-.557-.118-.67a.7.7,0,0,0-.66-.34.7.7,0,0,0-.66.34c-.089.113-.108.222-.118.675l-.02.537H44.312l-.02-.537c-.015-.582-.059-.695-.355-.912a.891.891,0,0,0-.848,0c-.3.217-.34.33-.355.912l-.02.537H38l-.02-.537c-.015-.582-.059-.695-.345-.907A.914.914,0,0,0,36.886-495.631Zm-.458,3.622c.015.581.059.695.355.912a.891.891,0,0,0,.848,0c.3-.217.34-.33.355-.912l.02-.537h4.711l.02.537c.015.581.059.695.355.912a.891.891,0,0,0,.848,0c.3-.217.34-.33.355-.912l.02-.537h4.711l.02.537c.015.581.059.695.355.912a.891.891,0,0,0,.848,0c.3-.217.34-.325.355-.917l.02-.542.646.02a2.125,2.125,0,0,1,.877.118,1.549,1.549,0,0,1,.7.7l.1.227v16.8l-.1.227a1.573,1.573,0,0,1-.7.7l-.227.1h-16.8l-.227-.1a1.573,1.573,0,0,1-.7-.7l-.1-.227-.015-8.254c-.01-5.9,0-8.328.039-8.511a1.393,1.393,0,0,1,.946-1.025,3.49,3.49,0,0,1,.788-.069l.572,0Z",
    transform: "translate(-89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24348",
    "data-name": "Path 24348",
    d: "M116.525-335.664a7.735,7.735,0,0,0-1.124,1.015l-1,.991-.582-.572a4.345,4.345,0,0,0-.715-.626.785.785,0,0,0-1,1.045,10.751,10.751,0,0,0,1,1.079c1.375,1.36,1.207,1.38,2.991-.394,1.395-1.395,1.513-1.542,1.444-1.892A.81.81,0,0,0,116.525-335.664Z",
    transform: "translate(-164.623 -152.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24349",
    "data-name": "Path 24349",
    d: "M256.574-303.711a.81.81,0,0,0-.448.892.843.843,0,0,0,.512.567c.123.039,1.148.049,3.124.039,2.883-.015,2.942-.015,3.075-.118a.7.7,0,0,0,.34-.66.7.7,0,0,0-.34-.66c-.133-.1-.192-.1-3.124-.113A22.254,22.254,0,0,0,256.574-303.711Z",
    transform: "translate(-301.592 -182.458)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24350",
    "data-name": "Path 24350",
    d: "M116.525-191.664a7.737,7.737,0,0,0-1.124,1.015l-1,.991-.582-.572a4.344,4.344,0,0,0-.715-.626.785.785,0,0,0-1,1.045,10.746,10.746,0,0,0,1,1.079c1.375,1.36,1.207,1.38,2.991-.394,1.395-1.395,1.513-1.542,1.444-1.892A.81.81,0,0,0,116.525-191.664Z",
    transform: "translate(-164.623 -289.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24351",
    "data-name": "Path 24351",
    d: "M256.574-159.711a.81.81,0,0,0-.448.892.843.843,0,0,0,.512.567c.123.039,1.148.049,3.124.039,2.883-.015,2.942-.015,3.075-.118a.7.7,0,0,0,.34-.66.7.7,0,0,0-.34-.66c-.133-.1-.192-.1-3.124-.113A22.256,22.256,0,0,0,256.574-159.711Z",
    transform: "translate(-301.592 -319.362)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskboard);
export default __webpack_public_path__ + "static/media/taskboard.36b3c67ccb899c3fe657380f15b9724f.svg";
export { ForwardRef as ReactComponent };